import { AssetDefinition, CreativeEngine } from "@cesdk/cesdk-js";

export const createDefaultApplyAssetScene =
  (engine: CreativeEngine) => async (asset: AssetDefinition) => {
    // Validate asset
    if (!asset.meta || !asset.meta.uri) {
      throw new Error("Asset does not have a uri");
    }

    try {
      // Load scene from the provided asset URI
      const scene = await engine.scene.loadFromURL(asset.meta.uri);

      // Ensure there is at least one page in the scene
      const pages = engine.block.findByType("page");
      if (pages.length === 0) {
        throw new Error("No pages found in the scene");
      }

      // Set page dimensions based on the first page
      const somePage = pages[0];
      const width = engine.block.getWidth(somePage);
      const height = engine.block.getHeight(somePage);

      engine.block.setFloat(scene, "scene/pageDimensions/height", height);
      engine.block.setFloat(scene, "scene/pageDimensions/width", width);
      engine.block.setString(scene, "scene/pageFormatId", "Custom");

      // Example of creating elements in the scene
      // Ensure that the URLs are valid and accessible
      await engine.scene.createFromImage(
        "https://img.ly/static/ubq_samples/sample_4.jpg"
      );
      await engine.scene.createFromVideo(
        "https://img.ly/static/ubq_video_samples/bbb.mp4"
      );

      // Save scene to a string and an archive
      const sceneString = await engine.scene.saveToString();
      await engine.scene.saveToArchive();

      return scene;
    } catch (error) {
      console.error("Error processing scene:", error);
      throw error;
    }
  };
